interface RGB {
  r: number
  g: number
  b: number
}

const hexToRgb = (hex: string): RGB | undefined => {
  let r
  let g
  let b
  if (hex.length <= 4) {
    const result = /^#?([a-f\d])([a-f\d])([a-f\d])$/i.exec(hex)
    if (!result) return

    r = parseInt(result[1] + result[1], 16)
    g = parseInt(result[2] + result[2], 16)
    b = parseInt(result[3] + result[3], 16)
  } else {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    if (!result) return

    r = parseInt(result[1], 16)
    g = parseInt(result[2], 16)
    b = parseInt(result[3], 16)
  }

  return { r, g, b }
}

export default hexToRgb
